import React from "react";
import { Button } from "react-bootstrap";
import { BiMinus, BiX } from "react-icons/bi";
import { BsCheck } from "react-icons/bs";
import PaginatedView from "../../../components/UI/PaginatedView/PaginatedView";
import { apiRoutes } from "../../../hooks/apiClient";
import funcionalidades from "../../../context/AuthContext.funcionalidades";

const columns = [
  {
    name: "Tipo de Documento",
    selector: "tipoDocumentoDescricao",
    width: "200px",
    sortable: true,
  },
  {
    name: "Tipo de Ação Fiscal",
    selector: "descricaoTipoAcaoFiscal",
    width: "200px",
    sortable: true,
    cell: (row) => {
      if (!row.sequenceTipoAcaoFiscal) {
        return (
          <Button variant="bg-transparent" className="btn-lg text-danger pa-0 p-0">
            <BiMinus />
          </Button>
        );
      }

      return row.descricaoTipoAcaoFiscal;
    },
  },
  {
    name: "Texto Padrão",
    cell: (row) => (
      <span
        aria-hidden
        onClick={(e) => e.preventDefault()}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: row.textoPadrao ?? "" }}
      />
    ),
  },
  {
    name: "Fisco-contábil",
    cell: (row) => {
      if (row.fgContabil) {
        return (
          <Button variant="bg-transparent" className="btn-lg text-success pa-0 p-0">
            <BsCheck />
          </Button>
        );
      }

      return (
        <Button variant="bg-transparent" className="btn-lg text-danger pa-0 p-0">
          <BiX />
        </Button>
      );
    },
    center: true,
    width: "10%",
  },
];

const ConsultaTextoPadrao = ({ history, match }) => (
  <PaginatedView
    title="Texto OS/SPF"
    keyField="sequenceTextoPadrao"
    descriptionField="textoPadrao"
    defaultSearch
    defaultSearchPlaceholder="Digite Texto OS/SPF"
    queryService={apiRoutes.fiscalizacao.parametrizacao.consultaTextoPadrao}
    deleteService={apiRoutes.fiscalizacao.parametrizacao.excluiTextoPadrao}
    editRoute={`${match.url}/form`}
    columns={columns}
    permissionDelete={funcionalidades.textoPadrao.deletar}
    permissionInsert={funcionalidades.textoPadrao.inserir}
    history={history}
  />
);

export default ConsultaTextoPadrao;
